import React, { useState, useEffect } from "react";

const Pagination = ({ showPerPage, onPaginationChange, total }) => {
  const [counter, setCounter] = useState(1);

  useEffect(() => {
    const value = showPerPage * counter;
    onPaginationChange(value - showPerPage, value);
  }, [counter]);

  const onButtonClick = (type) => {
    if (type === "prev") {
      if (counter === 1) {
        setCounter(1);
      } else {
        setCounter(counter - 1);
      }
    } else if (type === "next") {
      if (Math.ceil(total / showPerPage) === counter) {
        setCounter(counter);
      } else {
        setCounter(counter + 1);
      }
    }
  };
  
  return (
    <div className="d-flex justify-content-between">
    {total > 15 &&
      <button className="btn btn-primary dd" onClick={() => onButtonClick("prev")}>
        Previous
      </button>
    }
    {total > 15 &&
      <button className="btn btn-primary dds" onClick={() => onButtonClick("next")}>
        Next
      </button>
    }
    </div>
  );
};

export default Pagination;